import { render, staticRenderFns } from "./ChatListItem.vue?vue&type=template&id=18f06268&"
import script from "./ChatListItem.vue?vue&type=script&lang=js&"
export * from "./ChatListItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports